export default {
  listMaterials: (state) => state.listMaterials,
  arrayMaterial: (state) => state.arrayMaterial,
  fieldMaterial: (state) => state.fieldMaterial,
  fieldMaterialsRequest: (state) => state.fieldMaterialsRequest,
  listCategorys: (state) => state.listCategorys,
  listBrands: (state) => state.listBrands,
  listCatalogs: (state) => state.listCatalogs,
  loading: (state) => state.loading,
  pagination: (state) => state.pagination,
  materials: (state) => state.materials,
  optionUsers: (state) => state.optionUsers,
  entities: (state) => state.entities,
  listMaterialsRequests: (state) => state.listMaterialsRequests,
  materialRequestsDetail: (state) => state.materialRequestsDetail,
  fieldMaterialsRequestDetail: (state) => state.fieldMaterialsRequestDetail,
  services: (state) => state.services,
};
